<h2 mat-dialog-title class="text-center">Delete Account</h2>
<br />
<mat-dialog-content>
  <strong class="text-danger">
    Are you sure you want to delete your account?
    <br />
    <small>(All stores and products will be deleted)</small>
  </strong>
  <br />
  <br />
  <small class="text-info">To help us improve, what did Merchloop not accomplish for you?</small>
  <mat-form-field class="example-full-width">
    <textarea required matInput rows="5"
              class="comment-wh-product"
              [(ngModel)]="message"></textarea>
  </mat-form-field>
</mat-dialog-content>
<br />

<mat-dialog-actions style="float:right;">
  <button  class="btn btn-success" mat-dialog-close="false">No</button>
  &nbsp;
  <button [disabled]="!message" class="btn btn-danger"  [mat-dialog-close]="message" cdkFocusInitial>Yes</button>
</mat-dialog-actions>
